<template>
	<div class="systemSettings">
		<div class="systemSettingsScroll">
			<div class="systemSettings_head">
				<div class="systemSettings_title">System Settings</div>
				<button-groups isCancelHide @updateSave="onSave"></button-groups>
			</div>
			<div class="tabBlock">
				<div>
					<v-tabs
							class="tabList"
							v-model="tab"
							center-active
							height="40"
					>
						<v-tabs-slider color="#4CAF50"></v-tabs-slider>
						<v-tab
								v-for="item in getTabList"
								:disabled="item.disabled"
								:key="item.text"
								class="tab"
								:class="{'errorTab': item.error}"
						>
							{{ item.text }}
						</v-tab>
					</v-tabs>
					<v-tabs-items v-model="tab">
						<v-tab-item>
							<mail
									:valid="$v"
									:mailHost="mailHost"
									:mailPort="mailPort"
									:mailUserName="mailUserName"
									:mailPassword="mailPassword"
									:tabPermissionId="74"
									@updateMail="onMail"
							></mail>
						</v-tab-item>
						<v-tab-item>
							<map-keys
									:tabPermissionId="75"
									:valid="$v"
									:maps="maps"
									@updateDepartmentsList="onList($event, 'maps')"
									@updateDepartmentsListDelete="onDelete($event, 'maps')"
									@updateDepartmentsListEdit="onEdit($event, 'maps')"
							></map-keys>
						</v-tab-item>
						<v-tab-item>
							<trailer-types
									:tabPermissionId="76"
									:valid="$v"
									:trailerType="trailer_type"
									@updateDepartmentsList="onList($event, 'trailer_type')"
									@updateDepartmentsListDelete="onDelete($event, 'trailer_type')"
									@updateDepartmentsListEdit="onEdit($event, 'trailer_type')"
							></trailer-types>
						</v-tab-item>
						<v-tab-item>
							<statistics
									:tabPermissionId="77"
									:valid="$v"
									:dispatcher="dispatcher"
									:statistics="statistics_data"
									@updateStatisticsResult="onStatisticsResult"
							></statistics>
						</v-tab-item>
						<v-tab-item>
							<trucks-on-the-road
									:valid="$v"
									:tabPermissionId="78"
									:emails="trucksOnTheRoadEmailsList"
									@updateTrucksOnTheRoadEmailList="onList($event, 'trucksOnTheRoadEmailsList')"
									@updateTrucksOnTheRoadEmailDelete="onDelete($event, 'trucksOnTheRoadEmailsList')"
									@updateTrucksOnTheRoadEmailEdit="onEdit($event, 'trucksOnTheRoadEmailsList')"
							></trucks-on-the-road>
						</v-tab-item>
						<v-tab-item>
							<div class="pa-4">
								<v-btn
										color="primary"
										:loading="bankConnecting"
										:disabled="bankConnecting"
										@click="onConnectBank"
								>
									Connect
								</v-btn>
							</div>
						</v-tab-item>

					  <v-tab-item>
						  <departments-settings
					      :valid="$v"
							  :departments="departments"
				        @updateDepartmentsList="onList($event, 'departments')"
				        @updateDepartmentsListDelete="onDelete($event, 'departments')"
				        @updateDepartmentsListEdit="onEdit($event, 'departments')"
						  ></departments-settings>
					  </v-tab-item>
					</v-tabs-items>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// pages
import Mail from "@/pages/Settings/NewSystemSettings/Mail/Mail";
import MapKeys from "@/pages/Settings/NewSystemSettings/MapKeys/MapKeys";
import TrailerTypes from "@/pages/Settings/NewSystemSettings/TrailerTypes/TrailerTypes";
import Statistics from "@/pages/Settings/NewSystemSettings/Statistics/Statistics";
import TrucksOnTheRoad from "@/pages/Settings/NewSystemSettings/TrucksOnTheRoad/TrucksOnTheRoad";
import DepartmentsSettings from "@/pages/Settings/NewSystemSettings/DepartmentsSettings/DepartmetnsSettings";
// shared
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
// validate
import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";

export default {
	name: "NewSystemSettings",
	mixins: [ validationMixin ],
	components: {
		Mail,
		MapKeys,
		TrailerTypes,
		Statistics,
		TrucksOnTheRoad,
		ButtonGroups,
		// eslint-disable-next-line no-undef
		DepartmentsSettings
	},
	computed: {
		...mapGetters([
			'permissions',
			'dispatcher',
			'maps',
			'setting',
			'statistics_data',
			'trailer_type',
			'trucksOnTheRoadEmails',
			'departments'
		]),
		getTabList() {
			return [ {
				text: 'Mail',
				error: false,
				disabled: !this.permissions[74]
			},
			{
				text: 'Map KEYS',
				error: false,
				disabled: !this.permissions[75]
			},
			{
				text: 'Trailer Types',
				error: false,
				disabled: !this.permissions[76]
			},
			{
				text: 'Statistics',
				error: false,
				disabled: !this.permissions[77]
			},
			{
				text: 'Trucks on the road',
				error: false,
				disabled: !this.permissions[78]
			},
			{
				text: 'Bank connection',
				error: false,
				disabled: false
			}
			];
		}
	},
	data: () => ({
		bankConnecting: false,
		plaidHandler: null,
		
		tab: 0,
		mailHost: null,
		mailPort: null,
		mailUserName: null,
		mailPassword: null,
		mailHostValidations: null,
		mailPortValidations: null,
		mailUserNameValidations: null,
		mailPasswordValidations: null,
		trucksOnTheRoadEmailsList: null,
		mailList: null,
		settingAllList: null,
		statisticsList: null,
		afterHrsValidations: null,

		// Plaid
		plaidClientId: 'YOUR_PLAID_CLIENT_ID',
		plaidSecret: 'YOUR_PLAID_SECRET',
	}),
	validations() {
		return {
			trucksOnTheRoadEmailsList: {
				$each: {
					value: { required, email },
				}
			},
			departments: {
				$each: {
					value: { required },
				}
			},
			maps: {
				$each: {
					setting_value: { required },
				}
			},
			trailer_type: {
				$each: {
					name: { required },
				}
			},
			afterHrsValidations: { required },
			mailHostValidations: { required },
			mailPortValidations: { required },
			mailUserNameValidations: { required },
			mailPasswordValidations: { required },
		};
	},
	methods: {
		...mapActions([ 'exchangePlaidPublicToken', 'getLinkToken', 'getSystem', 'setSystem', 'getSystemDepartments', 'getSystemTrucksOnTheRoad', 'onSystemDepartments' ]),

		/**
		 * Get Plaid Link token and open Plaid Link.
		 *
		 * @return {Promise<void>}
		 */
		async onConnectBank() {
			if (this.bankConnecting) {
				return;
			}

			this.bankConnecting = true;

			try {
				if (!window.Plaid) {
					throw new Error(
						'Plaid Link SDK is not loaded'
					);
				}

				/*
				 * STEP 1
				 * Получаем link_token через Vuex/httpClient.
				 */
				const response = await this.getLinkToken();

				console.log(
					'[Plaid] response:',
					response
				);

				const linkToken = response
					? response.link_token
					: null;

				if (!linkToken) {
					throw new Error(
						'Plaid link_token was not received'
					);
				}

				console.log(
					'[Plaid] link_token received:',
					linkToken
				);

				/*
				 * Удаляем предыдущий Plaid instance.
				 */
				if (this.plaidHandler) {
					this.plaidHandler.destroy();
					this.plaidHandler = null;
				}

				/*
				 * STEP 2
				 * Создаём Plaid Link.
				 */
				this.plaidHandler = window.Plaid.create({
					token: linkToken,

					onSuccess: (publicToken, metadata) => {
						console.log(
							'[Plaid] SUCCESS public_token:',
							publicToken
						);

						console.log(
							'[Plaid] metadata:',
							metadata
						);

						this.onPlaidSuccess(
							publicToken,
							metadata
						);
					},

					onExit: (error, metadata) => {
						if (error) {
							console.error(
								'[Plaid Link exit error]',
								error,
								metadata
							);
						}

						this.destroyPlaidHandler();
					},

					onEvent: (eventName, metadata) => {
						console.log(
							'[Plaid Link event]',
							eventName,
							metadata
						);
					},
				});

				/*
				 * STEP 3
				 * Открываем Plaid.
				 */
				this.plaidHandler.open();
			} catch (error) {
				console.error(
					'[Plaid connect error]',
					error
				);
			} finally {
				this.bankConnecting = false;
			}
		},

		/**
		 * Handle successful Plaid connection.
		 *
		 * @param {string} publicToken Plaid public token.
		 * @param {Object} metadata Plaid metadata.
		 * @return {Promise<void>}
		 */
		async onPlaidSuccess(publicToken, metadata) {
			if (!publicToken) {
				return;
			}

			try {
				const response = await this.exchangePlaidPublicToken({
					public_token: publicToken,
					institution_id: metadata.institution
						? metadata.institution.institution_id
						: null,
					institution_name: metadata.institution
						? metadata.institution.name
						: null,
				});

				console.log(
					'[Plaid] Bank connection saved:',
					response
				);

				this.destroyPlaidHandler();
			} catch (error) {
				console.error(
					'[Plaid] Unable to save bank connection:',
					error
				);
			}
		},

		destroyPlaidHandler() {
			if (!this.plaidHandler) {
				return;
			}

			this.plaidHandler.destroy();
			this.plaidHandler = null;
		},

		onMail({ value, key }) {
			this[key] = value;
			this.mailList.find(item => {
				if ( item.setting_key === key ) item.setting_value = value;
			});
			if (key === 'MAIL_HOST') {
				this.mailHost = value;
				this.mailHostValidations = value;
			} else if (key === 'MAIL_PORT') {
				this.mailPort = value;
				this.mailPortValidations = value;
			} else if (key === 'MAIL_USERNAME') {
				this.mailUserName = value;
				this.mailUserNameValidations = value;
			} else if (key === 'MAIL_PASSWORD') {
				this.mailPassword = value;
				this.mailPasswordValidations = value;
			}
		},
		onStatisticsResult(args) {
			const { result, afterHrs } = args;
			this.statisticsList = result;
			if (afterHrs != 'onSelect' ) this.afterHrsValidations = afterHrs;
		},
		onEdit({ value, idx }, key) {
			if (key === 'maps') {
				this[key][idx]['setting_value'] = value;
			} else if (key === 'trailer_type') {
				this[key][idx]['name'] = value;
			} else {
				this[key][idx]['value'] = value;
			}
		},
		onList({ item, idx }, key) {
			if (idx !== undefined) {
				this[key].splice(idx, 1, item);
			} else {
				this[key].push(item);
			}
		},
		onDelete(idx, key) {
			if (key === 'maps' || key === 'trailer_type') {
				this[key][idx]['status'] = 0;
			} else {
				this[key].splice(idx, 1);
			}
		},
		async onSave() {
			this.$v.$touch();

			if (!this.$v.$error) {
				const values = { trucksOnTheRoad: this.trucksOnTheRoadEmailsList, statistics_data: {} };
				const systemOld = {
					dispatcher: this.dispatcher,
					maps: this.maps,
					setting: this.mailList,
					statistics_data: this.statisticsList,
					trailer_type: this.trailer_type };
				await this.setSystem({ values, departments: this.departments, systemOld });
			}
		}
	},

	async mounted() {
		await this.getSystem();
		await this.getSystemTrucksOnTheRoad();
		await this.getSystemDepartments();
		this.tab = this.getTabList.findIndex(item => !item.disabled);

		this.setting.map(item => {
			const { setting_key, setting_value } = item;
			if ( setting_key === 'MAIL_HOST') {
				this.mailHost = setting_value;
				this.mailHostValidations = setting_value;
			}
			if ( setting_key === 'MAIL_PORT') {
				this.mailPort = setting_value;
				this.mailPortValidations = setting_value;
			}
			if ( setting_key === 'MAIL_USERNAME') {
				this.mailUserName = setting_value;
				this.mailUserNameValidations = setting_value;
			}
			if ( setting_key === 'MAIL_PASSWORD') {
				this.mailPassword = setting_value;
				this.mailPasswordValidations = setting_value;
			}
		});

		this.statistics_data.map(item => {
			const { type, phone } = item;
			if ( type === 'afterHrs') this.afterHrsValidations = phone;
		});
		this.mailList = this.setting;

		this.trucksOnTheRoadEmailsList = this.trucksOnTheRoadEmails;
	},
	beforeDestroy() {
		this.destroyPlaidHandler();
	},
};
</script>

<style scoped lang="scss">
@import "NewSystemSettings";
</style>
<style lang="scss">
@import "NewSystemSettingsAll";
</style>
